import React from 'react';
import './ContinentCountrySearch.css';

const ContinentCountrySearch = (props) => {
  const { onSearchCountry } = props;

  let search_icon = (
    <svg class='bi bi-search searchIcon' width='1em' height='1em' viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' d='M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z'/>
      <path fill-rule='evenodd' d='M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z'/>
    </svg>
  );

  let input = (
    <input
      type={'text'}
      id={'countrySearch'}
      name={'countrySearch'}
      className={'countrySearchInput pl-5 p-2'}
      placeholder={'Search Countries'}
      onKeyUp={(e) => onSearchCountry(e.target.value)}/>

  );

  return (
    <React.Fragment>
      <div className='d-flex'>
        {input}
        {search_icon}
      </div>
    </React.Fragment>
  );
};

export default ContinentCountrySearch;



// WEBPACK FOOTER //
// ./src/components/Continent/ContinentCountrySearch/ContinentCountrySearch.jsx